import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  Box,
  Typography,
  Popover,
  IconButton,
  CircularProgress,
  useMediaQuery,
  useTheme,
  Collapse,
  Divider
} from "@mui/material";
import { Tooltip } from "@mui/material";
import {
  Description as FileIcon, ExpandMore,
  ExpandLess,
} from "@mui/icons-material";
import {
  getAllItems,
  deleteItem,
  ValueOfClosingStockExport,
} from "../../../Services/Services";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InfiniteScroll from "react-infinite-scroll-component";

import { useLocation } from "react-router-dom";

export default function Value_of_closing_stock() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [expandedItem, setExpandedItem] = useState(null);
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [excelLoading, setExcelLoading] = useState(false); // 🆕 Excel loading state
  const [filters, setFilters] = useState({
    item_code: "",
    name: "",
    category_name: "",
    sub_category: "",
    item_type: "",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);

  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1); // reset page
      fetchItems(1, false); // reset data with new filters
    }, 1000);

    return () => clearTimeout(handler);
  }, [filters]);

  const fetchItems = async (page = 1, append = false) => {
    const data = await getAllItems(page, filters);

    if (append) {
      setItems((prev) => [...prev, ...data.results]);
    } else {
      setItems(data.results);
    }

    setHasMore(!!data.next); // next page hai ya nahi
  };

  const fetchMoreData = () => {
    if (hasMore) {
      fetchItems(page + 1, true); // ✅ append mode
      setPage((prev) => prev + 1);
    }
  };
  const location = useLocation();


  useEffect(() => {
    document.body.style.overflow = isMobile ? 'auto' : 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobile]);
  useEffect(() => {
    if (location.state?.edited) {
      // Clear the navigation state so toast doesn't repeat on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const handleExcelExport = async () => {
    setExcelLoading(true);
    try {
      const blob = await ValueOfClosingStockExport(filters);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Value_of_closing_stock_${new Date().toISOString().split("T")[0]
        }.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      toast.success("Excel downloaded successfully!");
    } catch (error) {
      console.error("Export error:", error);
      toast.error("Failed to export Excel");
    } finally {
      setExcelLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteItem(id); // assume it just confirms deletion
      setItems((prev) => prev.filter((item) => item.id !== id)); // use passed `id`
      toast.success("Deleted successfully");
    } catch (err) {
      toast.error("Failed to delete");
    }
  };

  return (
    <>
      {/* ✅ Filters - Same as Original */}
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "stretch", sm: "center" }}
        sx={{
         mt: isMobile ? 4 : -3,
          pt: -3,
          mb: 2,
          width: "100%",
          gap: 1,
        }}
      >
        <ToastContainer position="top-right" autoClose={3000} />

        {/* Category Filter */}
        <TextField
          label="Category"
          value={filters.category_name}
          onChange={(e) =>
            setFilters({ ...filters, category_name: e.target.value })
          }
          size="small"
          sx={{
            width: "100%",
            "& .MuiInputBase-root": {
              height: 35,
              fontSize: "0.7rem",
              borderRadius: "0px",
            },
            "& .MuiInputLabel-root": {
              fontSize: "0.7rem",
            },
          }}
        />

        {/* Sub Category Filter */}
        {/* <TextField
          label="Sub Category"
          value={filters.sub_category}
          onChange={(e) =>
            setFilters({ ...filters, sub_category: e.target.value })
          }
          size="small"
          sx={{
            width: "100%",
            "& .MuiInputBase-root": {
              height: 35,
              fontSize: "0.7rem",
              borderRadius: "0px",
            },
            "& .MuiInputLabel-root": {
              fontSize: "0.7rem",
            },
          }}
        /> */}

        {/* Item Type Filter */}
        <TextField
          label="Product Type"
          value={filters.item_type}
          onChange={(e) =>
            setFilters({ ...filters, item_type: e.target.value })
          }
          size="small"
          sx={{
            width: "100%",
            "& .MuiInputBase-root": {
              height: 35,
              fontSize: "0.7rem",
              borderRadius: "0px",
            },
            "& .MuiInputLabel-root": {
              fontSize: "0.7rem",
            },
          }}
        />

        {/* Item Name Filter */}
        <TextField
          label="Item Name"
          value={filters.name}
          onChange={(e) => setFilters({ ...filters, name: e.target.value })}
          size="small"
          sx={{
            width: "100%",
            "& .MuiInputBase-root": {
              height: 35,
              fontSize: "0.7rem",
              borderRadius: "0px",
            },
            "& .MuiInputLabel-root": {
              fontSize: "0.7rem",
            },
          }}
        />

        {/* Excel Export Button */}
        <Box sx={{ minWidth: "40px", display: "flex", alignItems: "center" }}>
          <Tooltip
            title={excelLoading ? "Exporting..." : "Download Excel"}
            arrow
          >
            <span>
              <IconButton
                color="success"
                size="small"
                onClick={handleExcelExport}
                disabled={excelLoading}
                sx={{
                  borderRadius: "4px",
                  padding: "6px",
                }}
              >
                {excelLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <FileIcon fontSize="small" />
                )}
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      </Box>

      {/* ✅ Mobile/Desktop Conditional Rendering */}
      <InfiniteScroll
        dataLength={items.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
        endMessage={<p style={{ textAlign: "center" }}>No more items!</p>}
      >
        {isMobile ? (
          /* 📱 MOBILE VIEW - Collapsible Cards */
          <Box sx={{ bgcolor: "background.paper" }}>
            {items.length === 0 ? (
              <Box sx={{ textAlign: "center", py: 8 }}>
                <Typography variant="h6" color="text.secondary">
                  No Data Found
                </Typography>
              </Box>
            ) : (
              items.map((item, index) => (
                <Box key={index}>
                  {/* Item Header Card */}
                  <Box
                    onClick={() =>
                      setExpandedItem(
                        expandedItem === item.item_code ? null : item.item_code
                      )
                    }
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: 1.5,
                      cursor: "pointer",
                      bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                      "&:active": { bgcolor: "#e3f2fd" },
                      borderLeft: "4px solid #2196f3",
                    }}
                  >
                    <Box sx={{ flex: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 0.5,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#666",
                            minWidth: 25,
                          }}
                        >
                          #{index + 1}
                        </Typography>
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "0.85rem",
                            flex: 1,
                          }}
                        >
                          {item.item_code}
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          fontSize: "0.75rem",
                          color: "#666",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <span style={{ fontWeight: 500 }}>
                          {item.name || "N/A"}
                        </span>
                        <span style={{ color: "#999" }}>•</span>
                        <span
                          style={{
                            fontSize: "0.72rem",
                            fontWeight: 600,
                            color:
                              item.current_stock > 0 ? "#4caf50" : "#f44336",
                          }}
                        >
                          Stock: {item.current_stock}
                        </span>
                      </Typography>
                    </Box>
                    <IconButton size="small" sx={{ ml: 1 }}>
                      {expandedItem === item.item_code ? (
                        <ExpandLess fontSize="small" />
                      ) : (
                        <ExpandMore fontSize="small" />
                      )}
                    </IconButton>
                  </Box>

                  {/* Item Details - Collapsible */}
                  <Collapse
                    in={expandedItem === item.item_code}
                    timeout="auto"
                    unmountOnExit
                  >
                    <Box
                      sx={{
                        px: 1.5,
                        py: 1,
                        bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                        borderLeft: "4px solid #2196f3",
                      }}
                    >
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: 0.8,
                        }}
                      >
                        {/* Item Code */}
                        <Box sx={{ gridColumn: "1 / -1" }}>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            ITEM CODE
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.75rem",
                              fontWeight: 600,
                              color: "#1976d2",
                            }}
                          >
                            {item.item_code}
                          </Typography>
                        </Box>

                        {/* Item Name */}
                        <Box sx={{ gridColumn: "1 / -1" }}>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            ITEM NAME
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#333",
                            }}
                          >
                            {item.name || "-"}
                          </Typography>
                        </Box>

                        {/* Category */}
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            CATEGORY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {item.category_name || "-"}
                          </Typography>
                        </Box>

                        {/* Sub Category */}
                        {/* <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            SUB CATEGORY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {item.subcategory_name || "-"}
                          </Typography>
                        </Box> */}

                        {/* Item Type */}
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            ITEM TYPE
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {item.item_type || "-"}
                          </Typography>
                        </Box>

                        {/* Unit */}
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            UNIT
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {item.unit_name || "-"}
                          </Typography>
                        </Box>

                        {/* Current Stock */}
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            CURRENT STOCK
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 600,
                              color:
                                item.current_stock > 0 ? "#4caf50" : "#f44336",
                            }}
                          >
                            {item.current_stock || 0}
                          </Typography>
                        </Box>

                        {/* Last Rate */}
                        {/* Actual Price */}
<Box>
  <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px" }}>
    ACTUAL PRICE
  </Typography>
  <Typography sx={{ fontSize: "0.72rem", fontWeight: 600, color: "#9c27b0" }}>
    ₹ {item.price ?? 0}
  </Typography>
</Box>

{/* Previous Price */}
<Box>
  <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px" }}>
    PREVIOUS PRICE
  </Typography>
  <Typography sx={{ fontSize: "0.72rem", fontWeight: 600, color: "#607d8b" }}>
    ₹ {item.old_price ?? 0}
  </Typography>
</Box>

{/* Stock Value */}
<Box sx={{ gridColumn: "1 / -1" }}>
  <Typography sx={{ fontSize: "0.6rem", color: "#999", letterSpacing: "0.5px" }}>
    STOCK VALUE
  </Typography>
  <Typography sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#ff9800" }}>
    ₹ {(item.current_stock * (item.price ?? 0)).toFixed(2)}   {/* ✅ price use karo */}
  </Typography>
</Box>
                        {/* Stock Value */}
                        {/* <Box sx={{ gridColumn: "1 / -1" }}>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            STOCK VALUE
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.75rem",
                              fontWeight: 600,
                              color: "#ff9800",
                            }}
                          >
                            ₹ {(item.current_stock * item.rate).toFixed(2)}
                          </Typography>
                        </Box> */}
                      </Box>
                    </Box>
                  </Collapse>
                  <Divider />
                </Box>
              ))
            )}
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW - Original Table */
          <TableContainer
            component={Paper}
            id="item-table"
            sx={{
              maxHeight: "88vh",
              overflowX: { xs: "auto", sm: "unset" },
              overflowY: "auto",
              width: "100%",
            }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: "max-content",
                "& td, & th": {
                  borderBottom: "1px solid #ccc",
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <TableHead
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                  },
                }}
              >
                <TableRow>
                  {/* Sticky S.No */}
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                      minWidth: 50,
                      padding: "0px",
                    }}
                  >
                    S. No.
                  </TableCell>

                  {/* <TableCell>Item Code</TableCell> */}
                  <TableCell align="right">Category</TableCell>
                  {/* <TableCell>Sub Category</TableCell> */}
                  {/* <TableCell>Item Type</TableCell> */}
                  <TableCell>Item Name</TableCell>
                  <TableCell align="right">Unit</TableCell>
                  <TableCell align="right">Current Stock</TableCell>
                  <TableCell>Actual Price</TableCell>      {/* rate → Actual Price */}
<TableCell>Previous Price</TableCell>    {/* ✅ New column */}
                  <TableCell>Stock Value</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {items.map((item, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                        "& td": { backgroundColor: "#e3f2fd !important" },
                      },
                      "& td": {
                        paddingTop: "2px !important",
                        paddingBottom: "2px !important",
                        fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "white" : "inherit",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "inherit",
                      },
                    }}
                  >
                    {/* Sticky S.No */}
                    <TableCell
                      align="center"
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#fafafa",
                        zIndex: 2,
                        minWidth: 50,
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    {/* <TableCell>{item.item_code}</TableCell> */}
                    <TableCell align="right">{item.category_name}</TableCell>
                    {/* <TableCell align="right">{item.subcategory_name}</TableCell> */}
                    {/* <TableCell>{item.item_type}</TableCell> */}
                    <TableCell>{item.name}</TableCell>
                    <TableCell align="right">{item.unit_name}</TableCell>
                    <TableCell align="right">{item.current_stock}</TableCell>
                    <TableCell>{item.price ?? 0}</TableCell>                          {/* ✅ price field */}
<TableCell>{item.old_price ?? 0}</TableCell> 
                    <TableCell>
                      {(item.current_stock * item.price).toFixed(2)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>
    </>
  );
}
